import { mapGetters, mapState, mapActions } from 'vuex';
import { lockScroll, unlockScroll } from '@/utils/helpers';

export default {
  props: {
    hideDelay: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      isVisible: false,
      hideTimeout: null,
      watchdogTimeout: null,
    };
  },
  computed: {
    ...mapState('app', ['newLoaderCounter']),
    ...mapGetters('app', ['newLoaderIsLoading']),
  },
  watch: {
    newLoaderIsLoading: {
      handler: 'newLoaderIsLoadingHandler',
      immediate: true,
    },
  },
  beforeUnmount() {
    if (this.isVisible) {
      unlockScroll();
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.watchdogTimeout) {
      clearTimeout(this.watchdogTimeout);
    }
  },
  methods: {
    ...mapActions('app', ['resetLoaderCounter']),
    newLoaderIsLoadingHandler(value) {
      if (value) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    },
    showLoader() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      this.watchdogTimeout = setTimeout(() => {
        this.resetLoaderCounter();
      }, 5000);

      if (!this.isVisible) {
        lockScroll();
      }

      this.isVisible = true;
    },
    hideLoader() {
      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.hideTimeout = setTimeout(() => {
        if (this.isVisible) {
          unlockScroll();
        }
        this.isVisible = false;
        this.hideTimeout = null;
      }, this.hideDelay);
    },
  },
};
